import type { OdinIconName } from '@myosh/odin-components'
import { IconButton, OdinIconSize } from '@myosh/odin-components'
import './action-icon.scss'

export interface ActionIconProps {
  icon: OdinIconName
  onClick: () => void
  hidden?: boolean
  iconTheme?: 'primary' | 'default'
}

const ActionIcon = ({ icon, onClick, hidden = false, iconTheme = 'primary' }: ActionIconProps) => {
  const getButtonClass = () => {
    let className = `action-icon ${iconTheme}`
    if (hidden) {
      className += ' hidden'
    }

    return className
  }

  return (
    <IconButton
      icon={icon}
      onClick={onClick}
      className={getButtonClass()}
      iconSize={OdinIconSize.ExtraSmall}
      iconClassName='action-icon__icon'
      aria-label={icon}
    />
  )
}

export default ActionIcon
